// @ts-ignore
/*
 * @Author: Evan 360313191@qq.com
 * @Date: 2024-09-07 01:38:14
 * @LastEditors: Evan 360313191@qq.com
 * @LastEditTime: 2024-09-07 01:39:00
 * @FilePath: \Mswap_devMain\src\constants\api.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const SERVER_URL = 'https://test-5900.mswap.info'
export const TOKENCONF_URL = '/api/v1/dapp/tokens/conf' //tokens配置
export const TVL_URL = '/api/v1/explore/daily/tvl' //总锁仓量折线图
export const VOLUME_URL = '/api/v1/explore/daily/tvl' //历史交易量折线图
export const TOPTOKENS_URL = '/api/v1/explore/top/tokens' //TOP代币列表
export const TOPPAIRS_URL = '/api/v1/explore/top/pairs' //TOP资金池列表
export const TRANSACTIONS_URL = '/api/v1/explore/transactions' //TOP交易列表
